import React from "react"

const Footer = () => {
    return (
      <footer className="footer-container">  
        <div className="footer-contact">
        </div>
   
        <div className="footer-legal">
          <p>&copy; 2023 Journeez</p>
          <p><a href="/privacy">Privacy Policy</a></p>
          <p><a href="/terms">Terms of Service</a></p>
        </div>
      </footer>
    );
  };
  
  export default Footer;
